const namespace = "Fenceline";

import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  // "namespace" : {
  name: "Fenceline",
  namespace,
  description: null,
  version: "0.1.0",
  icon: "mdi-gauge",
  parentRoute: "/",
  defaultRoute: "Report",
  accentColor: "#000080",
  childRoutes,
  component : () => import(/* webpackChunkName: "Fenceline-parent" */ "@/apps/fenceline/Application.vue"),
  navigation: [
    // {
    //   title: "Home",
    //   route: "home",
    //   icon: "mdi-hand",
    // },
    // {
    //   title: "Site",
    //   route: "site",
    //   icon: "mdi-help-circle",
    // },
  ],
  settings: {
    //azureAPIMUrl: '',
    azureAPIMUrl: 'https://api.nonprd.lyb.com/external/fenceline/api/v1/getfenceline/fenceline',
    //azureAPIMUrl: 'https://azfun-fenceline-dev.azurewebsites.net/api/FenceLineGetSPdata?code=GzmI0NVVALnIHJds1nMM2FQaRAN1dUVNyZudWvtnwcc5qMGdnW4umQ==',
    //azureAPIMUrl: 'https://localhost:7071/api/FenceLineGetSPdata?code=GzmI0NVVALnIHJds1nMM2FQaRAN1dUVNyZudWvtnwcc5qMGdnW4umQ==',
  },
  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    themeColor : {
      default: "red",
      storageMode : localStorage,
    },
    isTrue : {
      default: true,
      storageMode : sessionStorage,
    },
    images: {
      default: [],
      storageMode : localStorage,
    },
    plants: {
      default: [],
      storageMode : localStorage,
    }
  }

}

export default AppConfig.merge(appConfig);


